import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import Swal from 'sweetalert2';
import { TegelModule } from '@scania/tegel-angular-17';
import { FullReservation } from '../../core/models/reservation/full-reservation';
import { ReservationService } from '../../core/services/application/flexseat/reservation.service';
import { DateService } from '../../core/services/application/util/date/date.service';
import { GraphService } from '../../core/services/application/util/graph/graph.service';

@Component({
  selector: 'app-home',
  imports: [TegelModule, DatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  private readonly reservationService = inject(ReservationService);
  private readonly graphService = inject(GraphService);
  private readonly dateService = inject(DateService);


  userReservation = this.reservationService.userFutureReservation;

  /** Computed properties 
   * @returns reservations sorted by date */
  get sortedUserReservations(): FullReservation[] {
    const reservations = this.userReservation();
    if (!reservations || reservations.length === 0) {
      return [];
    }

    return [...reservations].sort((a, b) => {
      const dateA = new Date(a.reservationDate || 0);
      const dateB = new Date(b.reservationDate || 0);
      return dateA.getTime() - dateB.getTime(); // Ordena da mais antiga para a mais recente
    });
  }
  
  /** Handles a click event on a card element. */
  handleCardClick(event: Event): void {
    console.log(event);
  }

  /** Cancels reservation */
  async cancelReservation(reserva: FullReservation) {
    const result = await Swal.fire({
      title: 'Deseja cancelar a reserva?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    });

    if (result.isConfirmed) {
      try {
        await this.reservationService.cancelReservationMethod(reserva, this.graphService.userGraphData()!.employeeId);
        await Swal.fire({ icon: 'success', title: 'Reserva cancelada com sucesso!' });
      } catch (error) {
        console.error('Erro ao cancelar reserva:', error);
        await Swal.fire({ icon: 'error', title: 'Erro ao cancelar reserva', text: 'Tente novamente.' });
      }
    }
  }

  /** Execute check-in */
  async executeCheckin(reservation: FullReservation) {
    try {
      await this.reservationService.checkInReservationMethod(reservation);
    } catch (error) {
      console.error('Erro ao realizar check-in:', error);
    }
  }

  /** Checks if given date is today date  
   * @returns full today data (DD/MM/YYYY)
  */
  isToday(date: Date | string | null): boolean {
    if (!date) return false;

    const today = this.dateService.getCurrentDate();
    const compareDate = new Date(date);
    
    return today.getFullYear() === compareDate.getFullYear() &&
           today.getMonth() === compareDate.getMonth() &&
           today.getDate() === compareDate.getDate();
  }

}
